import { render, staticRenderFns } from "./bind_account_pop.vue?vue&type=template&id=0cd1c7b9"
import script from "./bind_account_pop.vue?vue&type=script&lang=js"
export * from "./bind_account_pop.vue?vue&type=script&lang=js"
import style0 from "./bind_account_pop.vue?vue&type=style&index=0&id=0cd1c7b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports